import { render, staticRenderFns } from "./PromotionPlatform.vue?vue&type=template&id=bd6926a0&scoped=true&"
import script from "./PromotionPlatform.vue?vue&type=script&lang=js&"
export * from "./PromotionPlatform.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPlatform.vue?vue&type=style&index=0&id=bd6926a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6926a0",
  null
  
)

export default component.exports